export interface PortalLayoutMount {
  unmount: () => void
}

export interface PortalLayoutOptions {
  language: string
  currency?: string
  keepLogin?: boolean
  keepCurrency?: boolean
  keepProduct?: boolean
  desktopOnly?: boolean
  loginWithReload?: boolean
  preRelease: boolean
  headerBg?: string
  unSupportLanguages?: string[]
  projectTag: string
  showFloatingService?: boolean
  showFloatingWhatsApp?: boolean
  showFloatingApp?: boolean
}

declare global {
  interface Window {
    hopegooLogin?: () => void
    _injectHPPCHeader: (target: Element, options: PortalLayoutOptions) => PortalLayoutMount
    _injectHPPCFooter: (target: Element, options: PortalLayoutOptions) => PortalLayoutMount
  }
}

let loading: Promise<void> | undefined

export function loadPortalLayout(baseUrl: string) {
  if (!loading) {
    const stylesheet = document.createElement('link')
    const script = document.createElement('script')
    loading = new Promise<void>((resolve, reject) => {
      stylesheet.rel = 'stylesheet'
      stylesheet.href = `${baseUrl}/hopegoo-portal-layout.css`
      document.head.appendChild(stylesheet)
      script.src = `${baseUrl}/hopegoo-portal-layout-lib.umd.js`
      script.onload = () => resolve()
      script.onerror = () => reject(new Error('Failed to load Hopegoo portal layout'))
      document.head.appendChild(script)
    }).catch((error) => {
      stylesheet.remove()
      script.remove()
      loading = undefined
      throw error
    })
  }
  return loading
}
